import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: (count: number) =>
      translate({
        id: 'userManagement.3pc.view.fieldTitle',
        values: { count },
      }),
    territoriesCount: (count: number) =>
      translate({ id: 'userManagement.3pc.view.territoriesCount', values: { count } }),
    allDrivers: translate({ id: 'global.all' }),
    allVehicles: translate({ id: 'global.all' }),
    vehiclesCount: (count: number) =>
      translate({ id: 'userManagement.3pc.view.vehiclesCount', values: { count } }),
    driversCount: (count: number) =>
      translate({ id: 'userManagement.3pc.view.driversCount', values: { count } }),
    vehiclesAccess: translate({ id: 'userManagement.3pc.vehiclesAccess.title' }),
    driversAccess: translate({
      id: 'userManagement.3pc.driversRestriction.title',
    }),
    showDetails: translate({ id: 'userManagement.3pc.view.showDetails' }),
    showMore: translate({ id: 'userManagement.3pc.view.showMore' }),
    showLess: translate({ id: 'userManagement.3pc.view.showLess' }),
  }))

  return api
}
